import { Fragment, useEffect } from "react"
import { useFormContext } from "react-hook-form"
import { useBillServiceCode } from "../hooks"
import { BillServiceValues } from "../types"

type BillServiceCodeProps = {
  code?: string
}

export const BillServiceCode = ({ code }: BillServiceCodeProps) => {
  const billServiceCode = useBillServiceCode()
  const { formState, setValue } = useFormContext<BillServiceValues>()
  
  useEffect(() => {
    if (!code && formState.isSubmitSuccessful) billServiceCode.refetch()

    // eslint-disable-next-line 
  }, [formState])

  useEffect(() => {
    if (!code && billServiceCode.data) setValue("referensi", billServiceCode.data)
    if (!code && billServiceCode.data) setValue("trx_code", billServiceCode.data)

    // eslint-disable-next-line
  }, [billServiceCode.data])
  
  return <Fragment>{code ?? billServiceCode.data}</Fragment>
}